const types = {
  CLEAR_CURRENT: 'ROLES_CLEAR_CURRENT',
  GET_REQUEST: 'ROLES_GET_REQUEST',
  GET_SUCCESS: 'ROLES_GET_SUCCESS',
  GET_FAILURE: 'ROLES_GET_FAILURE',

  SAVE_REQUEST: 'ROLES_SAVER_REQUEST',
  SAVE_SUCCESS: 'ROLES_SAVE_SUCCESS',
  SAVE_FAILURE: 'ROLES_SAVE_FAILURE',

  GETALL_REQUEST: 'ROLES_GETALL_REQUEST',
  GETALL_SUCCESS: 'ROLES_GETALL_SUCCESS',
  GETALL_FAILURE: 'ROLES_GETALL_FAILURE',

  DELETE_REQUEST: 'ROLES_DELETE_REQUEST',
  DELETE_SUCCESS: 'ROLES_DELETE_SUCCESS',
  DELETE_FAILURE: 'ROLES_DELETE_FAILURE',    

  UPDATE_REQUEST: 'ROLES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'ROLES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'ROLES_UPDATE_FAILURE'    

};

export default types;